import React from "react";
import { ChevronDown, ChevronUp } from "lucide-react"; // Icons for expand/collapse
import { SidebarItemProps } from "./SidebarItem.props";

const SidebarItem: React.FC<SidebarItemProps> = ({
	OnItemClick,
	OnSectionClick,
	childs,
	display,
	Icon,
	name,
	open,
	disabled = false,
	selectedItem,
}) => {
	// Handle item click
	function handleListItemClick(item: { name: string; display: string }) {
		OnItemClick && OnItemClick(item.name); // Trigger parent callback
	}

	// Handle section click
	function handleSectionClick() {
		if (disabled) return; // Do nothing if disabled
		OnSectionClick(name);
	}

	return (
		<div
			className={`w-full ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
		>
			{/* Section Header */}
			<div
				onClick={handleSectionClick}
				className={`flex items-center justify-between px-4 py-3 cursor-pointer bg-gradient-to-r from-sky-900 to-sky-700 hover:bg-gradient-to-r hover:from-sky-700 hover:to-sky-900 ${
					disabled ? "bg-gray-200" : "bg-gray-100 hover:bg-gray-200"
				}`}
			>
				{/* Icon and Label */}
				<div className="flex items-center gap-3 w-full h-full">
					<Icon
						className={`w-6 h-6 ${disabled ? "text-gray-400" : "text-white"}`}
					/>
					<span
						className={`font-Poppins font-medium text-md tracking-wider text-md ${disabled ? "text-gray-400" : "text-white"}`}
					>
						{display}
					</span>
				</div>

				{/* Expand/Collapse Icon */}
				{open ? (
					<ChevronUp
						className={`w-5 h-5 ${disabled ? "text-gray-400" : "text-white"}`}
					/>
				) : (
					<ChevronDown
						className={`w-5 h-5 ${disabled ? "text-gray-400" : "text-white"}`}
					/>
				)}
			</div>

			{/* Child Items */}
			<div
				className={`transition-all duration-300 ${
					open && !disabled
						? "max-h-screen opacity-100"
						: "max-h-0 opacity-0"
				} overflow-hidden`}
			>
				{childs.map((item, index) => (
					<div
						key={index}
						className={`flex items-center justify-between pl-10 pr-4 py-2.5 cursor-pointer transition duration-200 ${
							disabled || item.disabled
								? "bg-gray-200 text-gray-400 cursor-not-allowed"
								: selectedItem === item.name
									? "bg-gradient-to-r from-sky-50 to-sky-200 text-sky-700 border-r-[6px] border-orange-600"
									: "hover:bg-gradient-to-r hover:from-sky-50 hover:to-sky-200 hover:text-sky-700"
						}`}
						onClick={
							item.disabled
								? undefined // Prevents the click handler for disabled items
								: () => handleListItemClick(item)
						}
					>
						<span
							className={`font-Poppins font-medium text-sm tracking-wider ${
								disabled
									? "text-gray-400"
									: selectedItem === item.name
										? "font-semibold text-sky-700"
										: "font-normal text-gray-700"
							}`}
						>
							{item.display}
						</span>
					</div>
				))}
			</div>
		</div>
	);
};

export default SidebarItem;
